import { FC } from 'react';

interface BoxProps {
  label: string;
  value: string;
  logo?: string;
}
const BoxInfoOffer: FC<BoxProps> = ({ label, value, logo }) => (
  <div className="relative rounded-md border border-dark-gray-100 px-3 py-1.5">
    <p className="input-label-small font-medium text-dark-gray-300">{label}</p>
    <p className="body-small text-oxford-blue-500">{value}</p>
    {logo && (
      <img
        src={logo}
        alt="logo"
        className="absolute right-3 top-1/2 -translate-y-1/2"
      />
    )}
  </div>
);

export default BoxInfoOffer;
